import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const SideNavLink = styled(Link)`
  color: ${({ theme }) => theme.colors['neutral/700']};

  &:hover {
    color: ${({ theme }) => theme.colors['primary/500']};

    &::after {
      background-color: ${({ theme }) => theme.colors['primary/500']};
    }
  }

  &::after {
    background-color: ${({ theme }) => theme.colors['primary/1000']};
  }
`;

export const LogoutBtn = styled.button`
  color: ${({ theme }) => theme.colors['neutral/700']};

  &:hover {
    color: ${({ theme }) => theme.colors['primary/500']};

    &::after {
      background-color: ${({ theme }) => theme.colors['primary/500']};
    }
  }

  &::after {
    background-color: ${({ theme }) => theme.colors['primary/1000']};
  }
`;
